export const sortIdsComponent = <T>(key: string, a: T, b: T): number => {
    if (typeof a[key as keyof T] === 'number') {
        const minusOne = -1;
        const comparison = (a[key as keyof T] as number) - (b[key as keyof T] as number);
        if (comparison < 0) {
            return minusOne;
        }
        if (comparison > 0) {
            return 1;
        }
        return 0;
    }
    return (a[key as keyof T] as string).localeCompare(b[key as keyof T] as string);
};
